<template>
  <div ref="container">
    <div class="title-box">
      <div class="return" @click="handleBack">
        <img src="@assets/images/return-lg.png" class="lg" />
      </div>
      <div class="title">搜索商品</div>
      <div class="return" style="visibility: hidden;">
        <img src="@assets/images/return-lg.png" class="lg" />
      </div>
    </div>
    <div style="height: 0.96rem;"></div>
    <div class="searchGood">
      <div class="search acea-row row-between-wrapper">
        <div class="input acea-row row-between-wrapper">
          <span class="iconfont icon-sousuo2"></span>
          <form @submit.prevent="submit"></form>
          <input type="text" placeholder="点击搜索商品" v-model="search" />
        </div>
        <div class="bnt" @click="submit">搜索</div>
      </div>
      <div v-if="keywords.length">
        <div class="title">热门搜索</div>
        <div class="list acea-row">
          <div class="item" v-for="key of keywords" :key="key" @click="toSearch(key)">
            {{ key }}
          </div>
        </div>
      </div>
      <div class="line"></div>
      <GoodList :goodList="goodList" :isSort="false"></GoodList>
      <Loading :loaded="loadend" :loading="loading" v-if="goodList.length"></Loading>
    </div>
    <div class="noCommodity" v-cloak v-if="goodList.length === 0 && where.page > 1">
      <div class="noPictrue">
        <img src="@assets/images/noSearch.png" class="image" />
      </div>
      <recommend></recommend>
    </div>
  </div>
</template>
<script>
import Loading from "@components/Loading";
import GoodList from "@components/GoodList";
import { getSearchKeyword } from "@api/store";
import { trim } from "@utils";
import { getProducts } from "@api/store";
import Recommend from "@components/Recommend";
export default {
  name: "GoodSearch",
  components: {
    GoodList,
    Loading,
    Recommend,
    // Recommend,
    // GoodList
  },
  props: {},
  data: function() {
    return {
      keywords: [],
      search: "",
      where: {
        page: 1,
        limit: 20,
        keyword: "",
      },
      loading: false,
      loadend: false,
      goodList: [],
    };
  },
  mounted: function() {
    this.getData();
    this.$scroll(this.$refs.container, () => {
      console.log(123);
      !this.loading && this.getGoodlist();
    });
  },
  methods: {
    submit() {
      const search = trim(this.search) || "";
      if (!search) return;
      this.where.keyword = search;
      this.$set(this, "goodList", []);
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.getGoodlist();
    },
    // toSearch(s) {
    //   this.$router.push({ path: "/goods_list", query: { s } });
    // },
    getData() {
      getSearchKeyword().then((res) => {
        this.keywords = res.data;
      });
    },
    toSearch: function(key) {
      this.where.keyword = key;
      this.$set(this, "goodList", []);
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.getGoodlist();
    },
    getGoodlist: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      let q = that.where;
      getProducts(q).then((res) => {
        that.loading = false;
        that.goodList.push.apply(that.goodList, res.data);
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
      });
    },
    //返回上一页
    handleBack() {
      this.$router.back();
    },
  },
};
</script>
<style scoped>
.noCommodity {
  border-top: 0.05rem solid #f5f5f5;
}
.title-box {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 0.96rem;
  display: flex;
  justify-content: space-between; /* 左右贴边，中间自适应 */
  align-items: center; /* 垂直居中（可选） */
  background: white;
  border-bottom: #f0f0f0 1px solid;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  .title-box:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* 悬停时阴影变大 */
  }

  .title {
    margin: 0 auto; /* 关键：让中间元素自动居中 */
    letter-spacing: 1px;
  }
  .return {
    display: flex;
    flex-direction: row;
    align-items: center;
    .lg {
      width: 24px;
      height: 24px;
    }
    .close {
      font-size: 15px;
      margin-left: 10px;
    }
  }
}
</style>
